/**
 * `#modules` — 12 card (`template.html` dòng 788–811). Thứ tự là thứ tự thiết kế.
 */

/**
 * Một card module. `icon` và `tint` khai union tại nguồn thay vì để suy ra `string` — cùng lý do
 * với `tint` ở `hero.ts`: chỗ dùng khỏi ép kiểu, gõ sai là lỗi biên dịch ngay ở đây.
 *
 * `beta` tuỳ chọn nên mảng PHẢI được gán kiểu `readonly ModuleCardCopy[]`. Để `as const` thay thế
 * thì mỗi phần tử thành một kiểu literal riêng, `cards.map()` trả về union, và đọc `card.beta`
 * là lỗi biên dịch ở 10 phần tử không khai khoá đó.
 *
 * BA tint, không phải một: đếm toàn file ngày 2026-08-19 được brand 9 card, success 1 (Voice),
 * violet 2 (Wiki, Co-work). `reference.md` §3 chỉ ghi cặp brand — đã báo chủ skill, đừng "sửa"
 * chỗ này cho khớp tài liệu.
 */
interface ModuleCardCopy {
  readonly icon:
    | 'messages-square'
    | 'list-tree'
    | 'mic'
    | 'kanban'
    | 'blocks'
    | 'library'
    | 'book-open'
    | 'users'
    | 'sparkles'
    | 'search'
    | 'palette'
    | 'plug';
  readonly tint: 'brand' | 'success' | 'violet';
  readonly title: string;
  readonly body: string;
  readonly beta?: boolean;
}

const cards: readonly ModuleCardCopy[] = [
  {
    icon: 'messages-square',
    tint: 'brand',
    title: 'Chat',
    body: 'Channel công khai & riêng tư, tin nhắn đầy đủ định dạng, thread, cảm xúc, đính kèm.',
  },
  {
    icon: 'list-tree',
    tint: 'brand',
    title: 'Topic',
    body: 'Chia channel thành nhiều luồng con, mỗi luồng có badge chưa đọc và nhắc tên riêng.',
  },
  {
    icon: 'mic',
    tint: 'success',
    title: 'Voice',
    body: 'Phòng thoại luôn mở trong channel, thanh nổi để quay lại cuộc đang diễn ra.',
  },
  {
    icon: 'kanban',
    tint: 'brand',
    title: 'Quản lý công việc nhanh',
    body: 'Biến bất kỳ channel nào thành dự án Sprint, Kanban hoặc WBS.',
  },
  {
    icon: 'blocks',
    tint: 'brand',
    title: 'Business App',
    body: 'Quản lý dự án, Đào tạo, Phòng họp, Phê duyệt, Ticket.',
  },
  {
    icon: 'library',
    tint: 'brand',
    title: 'Knowledge Base',
    body: 'Kho tài liệu phân loại theo danh mục, có tìm kiếm và đánh dấu.',
  },
  {
    icon: 'book-open',
    tint: 'violet',
    title: 'Wiki',
    beta: true,
    body: 'Không gian tài liệu nội bộ có cấu trúc với trình soạn thảo riêng.',
  },
  {
    icon: 'users',
    tint: 'violet',
    title: 'Co-work',
    beta: true,
    body: 'Không gian làm việc chung thời gian thực giữa người và agent.',
  },
  {
    icon: 'sparkles',
    tint: 'brand',
    title: 'AI Agents',
    body: 'Không giới hạn số agent: dùng chung toàn công ty, riêng từng nhân viên, hoặc whitelist theo phòng ban.',
  },
  {
    icon: 'search',
    tint: 'brand',
    title: 'Search',
    body: 'Một ô tìm kiếm cho tin nhắn, con người, tài liệu và channel.',
  },
  {
    icon: 'palette',
    tint: 'brand',
    title: 'Design Studio',
    body: 'Thiết kế bằng cách nói chuyện với trợ lý, ngữ cảnh lấy từ Knowledge Base.',
  },
  {
    icon: 'plug',
    tint: 'brand',
    title: 'Connectors',
    body: 'Đưa hệ thống và dữ liệu bên ngoài vào trong workspace.',
  },
];

export const modules = {
  eyebrow: 'Nền tảng',
  heading: 'Mười hai module. Một lần đăng nhập. Một nguồn sự thật.',
  lead: 'Mọi module dùng chung thành viên, phân quyền và chỉ mục tìm kiếm — ngữ cảnh không còn phải chép qua lại giữa các công cụ.',
  cards,
};
